import runTransaction from "astrid-firestore/src/utils/runTransaction";

import { teamRoles } from "../../../constants/teamRoles";
import { getPriceRef } from "../../../utils/referenceMappers";

import offerStatuses from "../../offers/constants/offerStatuses";
import getOffersToCancel from "../../offers/utils/getOffersToCancel";
import addWorkNarrators from "../../works/addWorkNarrators";

import getProductionTeamMembers from "./getProductionTeamMembers";

export default async function addTeamMember(firebase, { member, offer, production, productionPrice }) {
	const db = firebase.firestore();

	// Get all offers to cancel
	const offersToCancel = await getOffersToCancel(db, offer);

	await runTransaction(firebase, [production.ref], async (transaction, [production]) => {
		// If the member is a reader, add them as a narrator on the work
		if (member.role === teamRoles.READER && production.work) {
			const existingNarrators = getProductionTeamMembers(production)
				.filter(({ role }) => role === teamRoles.READER)
				.map(({ user }) => user);

			await addWorkNarrators(
				firebase,
				{
					users: [...existingNarrators, member.user],
					production,
				},
				{ transaction },
			);
		}

		// Update the offer status to accepted
		if (offer?.ref) {
			transaction.update(offer.ref, {
				voiceId: offer.voiceId || null,
				status: offerStatuses.ACCEPTED,
				price: !productionPrice.price ? null : getPriceRef(productionPrice),
			});
		}

		// If the offer has a price, create a new price document
		if (productionPrice?.ref) {
			transaction.set(productionPrice.ref, productionPrice);
		}

		// If the price has a reference price, increment the uses counter
		if (productionPrice?.referencePrice?.maxUses) {
			transaction.update(productionPrice.agreement.ref, {
				[`prices.${productionPrice.referencePrice.id}.uses`]: firebase.firestore.FieldValue.increment(1),
			});
		}

		// Remove exisiting production price
		if (member?.price?.ref?.path.includes("productions") && member?.role !== teamRoles.RECORDER) {
			transaction.update(member.price.ref, {
				deleted: true,
			});
		}

		// If the offer is an inquiry, we need to cancel all other inquiries
		if (offersToCancel.length > 0) {
			for (const offer of offersToCancel) {
				transaction.update(offer.ref, {
					status: offerStatuses.CANCELLED,
				});
			}
		}

		// Add the member to the production team
		transaction.update(production.ref, {
			[`team.${member.id}`]: { ...member, price: getPriceRef(productionPrice) },
		});
	});

	return member;
}
